import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
var PrivateOutlet = function () {
    var auth = useAppSelector(function (state) { return state.auth.loginData; });
    // const auth = useAppSelector((state) => state.auth.whoamiData);
    var isLeftMenuOpen = useAppSelector(function (state) { return state.common.isMenuOpen; });
    var _a = useState('0px'), marginLeft = _a[0], setMarginLeft = _a[1];
    useEffect(function () {
        if (isLeftMenuOpen === true) {
            setMarginLeft("200px");
        }
        else {
            setMarginLeft("0px");
        }
    }, [isLeftMenuOpen]);
    return auth ? /*#__PURE__*/ React.createElement(Outlet, null) : /*#__PURE__*/ React.createElement(Navigate, {
        to: "/"
    });
};
export default PrivateOutlet;
